"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function Top10TippsAutoVerkaufen() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Top 10 Tipps: Auto verkaufen leicht gemacht"
        link="/guides/top-10-tipps-auto-verkaufen"
        linkname="Auto verkaufen Tipps"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Auf was muss ich achten, wenn ich mein Auto verkaufe?"
              leftText={
                <>
                  <p>
                    Ein Auto zu verkaufen kann schnell zur Herausforderung
                    werden. Du möchtest einen fairen Preis erzielen, gleichzeitig
                    aber nicht wochenlang Anzeigen schalten und unzählige
                    Probefahrten arrangieren. Mit unseren praxisnahen Tipps
                    meisterst du den Verkauf deines Gebrauchtwagens sicher und
                    ohne Stress. Und wenn du den Aufwand nicht selbst tragen
                    möchtest, hilft dir Autoeinfachlos mit einem Netzwerk von
                    über 5.000 geprüften Händlern – schnell, unkompliziert und
                    zum besten Preis.
                  </p>

                  <h2>Warum du Tipps für den Autoverkauf brauchst</h2>
                  <p>
                    Beim Verkauf stehen dir verschiedene Wege offen. Der
                    Privatverkauf bringt zwar oft etwas mehr Geld ein, erfordert
                    aber Zeit, Geduld und eine sorgfältige Vorbereitung. Der
                    Verkauf an einen Händler geht schneller, bringt aber meist
                    einen geringeren Preis, weil der Händler Risiko und Aufwand
                    einkalkuliert. Mit Autoeinfachlos bekommst du den besten
                    beider Welten: Du erhältst nach einer kostenlosen
                    Online-Bewertung Angebote aus einem großen Händlernetzwerk
                    und entscheidest selbst, welches du annimmst – ohne Aufwand,
                    aber zu einem fairen Preis.
                  </p>

                  <h2>Top 10 Tipps – so verkaufst du dein Auto erfolgreich</h2>
                  <ol className="custom-ordered-list">
                    <li>
                      <strong>Auto gründlich reinigen:</strong> Ein gepflegtes
                      Fahrzeug macht einen besseren Eindruck. Wasche Karosserie
                      und Felgen sorgfältig, reinige Innenraum und Fenster mit
                      Auto-Shampoo, Schwamm und Mikrofasertüchern. Selbstwäschen
                      sind nur erlaubt, wenn das Abwasser nicht in den Boden
                      gelangt.
                    </li>
                    <li>
                      <strong>Wert realistisch ermitteln:</strong> Vergleiche
                      ähnliche Fahrzeuge in Inseraten und nutze professionelle
                      Bewertungs-Tools. Berücksichtige Alter, Laufleistung,
                      Zustand und Ausstattung.
                    </li>
                    <li>
                      <strong>Attraktive Fotos & ehrliche Beschreibung:</strong>{" "}
                      Gute Fotos aus verschiedenen Perspektiven und eine
                      detaillierte Beschreibung von Ausstattung und Mängeln
                      erhöhen die Verkaufschancen. Verschweige keine Schäden.
                    </li>
                    <li>
                      <strong>Alle Dokumente bereithalten:</strong> Halte
                      Zulassungsbescheinigungen Teil I und II, HU-Bericht
                      (Pickerl) und Serviceheft bereit. Übergebe alle Schlüssel,
                      Betriebsanleitung sowie einen schriftlichen Kaufvertrag.
                    </li>
                    <li>
                      <strong>Kaufvertrag schriftlich festhalten:</strong> Ein
                      schriftlicher Vertrag schützt beide Seiten. Halte fest, in
                      welchem Zustand das Fahrzeug übergeben wird.
                    </li>
                    <li>
                      <strong>Probefahrt organisieren:</strong> Vereinbare
                      Termine nur mit ernsthaften Interessenten, prüfe
                      Führerschein und Ausweis und begleite die Fahrt.
                    </li>
                    <li>
                      <strong>Sichere Zahlungsmethode wählen:</strong>{" "}
                      Banküberweisung oder ein Notaranderkonto sind sicherer als
                      Bargeld oder Schecks.
                    </li>
                    <li>
                      <strong>Abmeldung und Ummeldung klären:</strong> Ist das
                      Auto noch zugelassen, setze dem Käufer im Kaufvertrag eine
                      Frist für die Ummeldung; ansonsten zahlst du weiter
                      Versicherung und Steuer.
                    </li>
                    <li>
                      <strong>Den richtigen Zeitpunkt wählen:</strong> Im
                      Frühling oder Herbst suchen mehr Käufer. Im Hochsommer ist
                      die Nachfrage schwächer.
                    </li>
                    <li>
                      <strong>Autoeinfachlos als Alternative nutzen:</strong>{" "}
                      Wenn dir der Privatverkauf zu aufwendig ist, bietet
                      Autoeinfachlos eine schnelle Lösung. Du erhältst Angebote
                      von über 5.000 Händlern, wählst das beste aus und wir holen
                      das Auto ab. Die Zahlung erfolgt sofort.
                    </li>
                  </ol>
                </>
              }
              rightFirstTitle="Deine Verkaufsoptionen – privat, Händler oder Autoeinfachlos?"
              rightFirstText={
                <>
                  <p>
                    Der Privatverkauf bringt oft den höchsten Erlös, erfordert
                    jedoch viel Zeit und birgt Risiken wie unseriöse
                    Interessenten. Der Verkauf an einen Händler ist schneller,
                    aber der Preis ist niedriger. Autoeinfachlos kombiniert die
                    Vorteile: Du erhältst mehrere verbindliche Angebote,
                    verkaufst sicher und sparst dir den Aufwand.
                  </p>

                  <h3>Preisfaktoren – was bestimmt den Wert deines Autos?</h3>
                  <p>
                    Den Ankaufspreis bestimmen Alter und Erstzulassung,
                    Laufleistung, Wartungs- und Unfallhistorie, Marke und Modell,
                    Zahl der Vorbesitzer, Ausstattung, allgemeiner Zustand sowie
                    die aktuelle Marktlage. Je besser du dein Auto gepflegt hast,
                    desto höher fällt der Preis aus. Nutze unser Bewertungs-Tool,
                    um den genauen Restwert zu ermitteln – oft ist er höher als
                    gedacht.
                  </p>
                </>
              }
              rightSecondTitle="Häufig gestellte Fragen zum Autoverkauf"
              rightSecondText={
                <>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Kann ich ein Auto mit Motorschaden verkaufen?</strong>{" "}
                      Ja. Defekte Fahrzeuge dürfen verkauft werden, sollten aber
                      ehrlich deklariert werden.
                    </li>
                    <li>
                      <strong>Muss ich Mängel angeben?</strong> Ja. Du musst
                      bekannte Schäden und Unfälle offenlegen. Verschweigen kann
                      zu Gewährleistungsansprüchen führen.
                    </li>
                    <li>
                      <strong>Wer kümmert sich um die Abmeldung?</strong> Bei
                      Autoeinfachlos übernehmen wir die Abmeldung und holen das
                      Fahrzeug ab. Beim Privatverkauf solltest du das Auto vor
                      der Übergabe abmelden oder dem Käufer eine Frist setzen.
                    </li>
                  </ul>
                </>
              }
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Auto verkaufen Tipps"
                kaputtesAuto
                unfallAuto
                autoExport
                autoVerkaufen
                autoBewerten
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit zum Autoverkauf"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ihr Auto zu verkaufen."
                text={
                  <>
                    <p>
                      Mit der richtigen Vorbereitung und unseren Top-Tipps
                      gelingt der Autoverkauf schnell und zu einem fairen Preis.
                      Willst du dir den Aufwand sparen, nutze Autoeinfachlos: Wir
                      bieten dir eine transparente, sichere Abwicklung und den
                      besten Preis durch unser Netzwerk von 5.000 Händlern.
                      Berechne jetzt kostenlos den Wert deines Autos und starte
                      den Verkauf.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default Top10TippsAutoVerkaufen;
